document.addEventListener('DOMContentLoaded', function () {
  cardCounter()
})
